export default __webpack_public_path__ + "mixer-dual.png?be6317ccfbb32e46909d8dee6cb96274";